import { pickDefaultCustomerAddress } from '#/modules/crmMgmt/customer/helper/customerAddress';

export function formatCustomerAddressLine(row) {
  if (!row) {
    return '';
  }
  return [row.postalCode, row.address].filter(Boolean).join(' ');
}

/** 預設地址：帳單預設 → 出貨預設 → 任一預設 → 第一筆。 */
export function pickRepairSnapshotAddress(addresses = []) {
  return pickDefaultCustomerAddress(addresses, 'BILLING')
    ?? pickDefaultCustomerAddress(addresses, 'SHIPPING')
    ?? (addresses ?? []).find((row) => row?.isDefault)
    ?? (addresses ?? [])[0]
    ?? null;
}

function pickById(rows = [], rowId) {
  if (!rowId) {
    return null;
  }
  return (rows ?? []).find((row) => row?.id === rowId) ?? null;
}

/** 客戶區快照欄（選客戶時帶入）。 */
export const EMPTY_REPAIR_CUSTOMER_SNAPSHOT = {
  customerName: '',
  taxId: '',
  fax: '',
  addressId: '',
  address: '',
};

/** 聯絡人區快照欄（選「帶入聯絡人」時帶入）。 */
export const EMPTY_REPAIR_CONTACT_SNAPSHOT = {
  contactId: '',
  contactName: '',
  phone: '',
};

/**
 * 選客戶 → 客戶名稱、統編、傳真、預設地址（含 addressId 供地址下拉顯示）。
 * 聯絡人、電話不在此帶入。
 *
 * @param {object | null | undefined} customerDetail
 */
export function mapCustomerDetailToRepairCustomerSnapshot(customerDetail) {
  if (!customerDetail) {
    return { ...EMPTY_REPAIR_CUSTOMER_SNAPSHOT };
  }

  const address = pickRepairSnapshotAddress(customerDetail.addresses);

  return {
    customerName: customerDetail.name ?? '',
    taxId: customerDetail.taxIdNumber ?? '',
    fax: customerDetail.fax ?? '',
    addressId: address?.id ?? '',
    address: formatCustomerAddressLine(address),
  };
}

/**
 * 選地址下拉 → 地址字串；找不到回 null（呼叫端不覆蓋）。
 *
 * @param {object | null | undefined} customerDetail
 * @param {string | null | undefined} addressId
 */
export function mapCustomerAddressToRepairAddress(customerDetail, addressId) {
  const row = pickById(customerDetail?.addresses, addressId);
  return row ? formatCustomerAddressLine(row) : null;
}

/**
 * 選「帶入聯絡人」→ 聯絡人、電話（與下拉標籤一致：mobile 優先，否則 phone）。
 *
 * @param {object | null | undefined} customerDetail
 * @param {string | null | undefined} contactId
 */
export function mapCustomerContactToRepairSnapshot(customerDetail, contactId) {
  const contact = pickById(customerDetail?.contacts, contactId);
  return {
    contactName: contact?.name ?? '',
    phone: contact?.mobile || contact?.phone || '',
  };
}
